import { render, staticRenderFns } from "./LinkAnMemberBenefit.vue?vue&type=template&id=c4dbf344&"
import script from "./LinkAnMemberBenefit.vue?vue&type=script&lang=js&"
export * from "./LinkAnMemberBenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports